module.exports = __webpack_public_path__ + "img/1542472209.ddfd28fe.jpg";